import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const tenable = defineConnector({
  identifier: "tenable",
  name: "Tenable",
  tagLine: "Vulnerability management",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://cloud\\.tenable\\.com/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "X-ApiKeys",
        value: `accessKey=${app.secret.accessKey};secretKey=${app.secret.secretKey}`,
      },
    ]),
  steps: [
    {
      title: "Get your Tenable API keys",
      items: [
        {
          kind: "markdown",
          content:
            "In Tenable.io, go to **Settings > My Account > API Keys** and generate a new access key and secret key pair.",
        },
      ],
    },
    {
      title: "Enter your API keys",
      items: [
        {
          kind: "input",
          label: "Access key",
          required: true,
          target: { kind: "secrets", field: "accessKey" },
        },
        {
          kind: "input",
          label: "Secret key",
          required: true,
          target: { kind: "secrets", field: "secretKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://cloud.tenable.com/scans",
  },
});
